<template>
  <el-dialog
    class="privacy-policy-modal"
    :title="$t('footer.privacyPolicy')"
    :visible.sync="dialogVisible"
    :width="modalWidth"
    :before-close="handleClose">
    <div>
      <p>株式会社アクティは、当社の事業活動において、個人情報保護の重要性を強く認識し、当社の事業活動に必要な範囲内で、以下の基本的な方針に基づき、個人情報及び特定個人情報の保護に努めます。</p>

      <h4>１	個人情報の定義</h4>
      <p>本プライバシーポリシーにおける、「個人情報」とは、個人情報の保護に関する法律規定される「個人情報」及び当社サービスの利用に係るパスワードを指します。</p>

      <h4>２	個人情報の取得</h4>
      <p>当社は、利用目的の達成に必要な範囲で、個人情報を適正に取得し、不正の手段により取得することはありません。</p>

      <h4>３	利用目的</h4>
      <p>当社は、取得した個人情報を以下の目的で利用します。</p>

      <p>①当社サービスのおけるサービスに関する情報の通知</p>
      <p>②当社に関するお問い合わせ等への対応</p>
      <h4>４	第三者提供</h4>
      <p>当社は、法令に定められた場合を除き、あらかじめ利用者の同意を得ないで、第三者（日本国外にあるも者を含みます。）に個人情報を提供しません。</p>
      <h4>５	開示、訂正、利用停止、削除</h4>
      <p>当社は、利用者から個人情報の開示、訂正、利用停止、削除を求められたときは、法令に定められた場合を除き、本人確認の上で、遅滞なく開示を行います。</p>
      <p>ただし、個人情報の開示につきましては、１件あたり１，０００円の手数料を頂戴しておりますので、あらかじめご了承ください。</p>
      <h4>６	お問い合わせ窓口</h4>
      <p>個人情報の取り扱いに関するお問い合わせは、下記の窓口までお願いいたします。電話番号：045-620-8845</p>
      <h4>７	プライバシーポリシー</h4>
      <p>当社は、必要に応じて、本プライバシーポリシーを変更いたします。</p>
      <p>なお、本プライバシーポリシーを変更する場合は、その内容を当社のウェブサイト上で表示いたします。</p>
      <p>【2021年12月15日制定】</p>
      <div class="text-left">
        <el-button class="confirm-btn" @click="handleClose">{{$t('footer.confirm')}}</el-button>
      </div>
    </div>
    <!-- <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleClose">{{$t('footer.confirm')}}</el-button>
    </span> -->
  </el-dialog>
</template>

<script>
export default {
  name: 'DetailsNew',
  props: {
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      dialogVisible: false,
      modalWidth: '80%'
    }
  },
  watch: {
    isOpen() {
      this.dialogVisible = this.isOpen;
    }
  },
  created() {
    this.getWidth();
  },
  methods: {
    openPrivacyPolicy() {
      this.dialogVisible = true;
    },
    handleClose() {
      this.dialogVisible = false;
      this.$emit('modalClose');
    },
    getWidth() {
      let width = `${document.documentElement.clientWidth}`;
      if (width < 992) {
        this.modalWidth = '95%'
      } else {
        this.modalWidth = '80%'
      }
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/scss" lang="scss" scoped>
@import '@/style/variables.scss';
.privacy-policy-modal {
  .confirm-btn {
    color: #606266;
    background-color: #FFF;
    margin-left: 2em;
  }
  p {
    font-size: 1rem;
    text-align: left;
    text-indent: 2em;
    line-height: 30px;
  }
  h4 {
    font-size: 1.1rem;
    text-indent: 2em;
    text-align: left;
    margin-top: 20px;
    margin-bottom: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/privacy-policy-modal.vue